import React from 'react';
import { useSubscription } from '../../contexts/SubscriptionContext';

interface PremiumGateProps {
  feature: string;
  description?: string;
  onUpgrade: () => void;
  children: React.ReactNode;
}

/**
 * Wraps a premium-only view. Shows the feature to premium users; otherwise renders a Paywall.
 */
const PremiumGate: React.FC<PremiumGateProps> = ({ feature, description, onUpgrade, children }) => {
  const { isPremium, loading } = useSubscription();

  if (loading) {
    return (
      <div style={{ padding: '48px', textAlign: 'center' }}>
        <div style={{ width: 30, height: 30, border: '3px solid #e5e7eb', borderTop: '3px solid #667eea', borderRadius: '50%', margin: '0 auto', animation: 'spin 1s linear infinite' }} />
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }

  if (isPremium) return <>{children}</>;

  return (
    <div data-testid={`paywall-${feature.toLowerCase().replace(/\s+/g, '-')}`} style={{ padding: '40px 24px', textAlign: 'center' }}>
      <div style={{ maxWidth: '460px', margin: '0 auto', background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', borderRadius: '20px', padding: '36px 28px', color: 'white', boxShadow: '0 12px 40px rgba(102,126,234,0.35)' }}>
        <div style={{ fontSize: '2.6rem', marginBottom: '10px' }}>🔒</div>
        <h2 style={{ margin: 0, fontSize: '1.5rem', fontWeight: 800 }}>{feature} is a Premium feature</h2>
        <p style={{ margin: '12px 0 0 0', fontSize: '0.95rem', opacity: 0.92, lineHeight: 1.5 }}>
          {description || `Unlock ${feature} and every other premium tool in Yojana with a subscription.`}
        </p>
        <button
          onClick={onUpgrade}
          data-testid="paywall-upgrade-btn"
          style={{ marginTop: '22px', padding: '13px 28px', backgroundColor: 'white', color: '#5b21b6', border: 'none', borderRadius: '12px', fontWeight: 800, fontSize: '1rem', cursor: 'pointer' }}
        >
          Upgrade to Premium ✨
        </button>
        <p style={{ margin: '14px 0 0 0', fontSize: '0.78rem', opacity: 0.8 }}>Starts at ₹99/month · Cancel anytime</p>
      </div>
    </div>
  );
};

export default PremiumGate;
